import React, { useEffect } from 'react';

export default function HubSpotContactForm() {
    useEffect(() => {
        const target = document.getElementById('hubspotForm');
        if (!target) return;

        target.innerHTML = '';

        const run = () => {
            if (!window.hbspt) return;

            target.innerHTML = '';

            window.hbspt.forms.create({
                portalId: '5688825',
                formId: '29fbe6f2-c39d-4b99-8530-1eefb5e26db7',
                region: 'na1',
                target: '#hubspotForm',
            });
        };

        const existingScript = document.querySelector(
            'script[src="https://js.hsforms.net/forms/embed/v2.js"]'
        );

        if (window.hbspt) {
            setTimeout(run, 0);
        } else if (existingScript) {
            existingScript.addEventListener('load', run, { once: true });
        } else {
            const script = document.createElement('script');
            script.src = 'https://js.hsforms.net/forms/embed/v2.js';
            script.async = true;
            script.onload = run;
            document.body.appendChild(script);
        }

        return () => {
            if (target) target.innerHTML = '';
        };
    }, []);

    return <div id="hubspotForm" className="hubspotFormWrap" />;
}
